import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logoImg from '../assets/logo.webp';
import './Footer.css';

export default function Footer() {
  const navigate = useNavigate();
  const handleNavClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="main-footer-section">
      <div className="container footer-container">
        <div className="grid-3" style={{ gap: '50px' }}>
          {/* Company branding */}
          <div className="footer-brand-column">
            <div className="footer-logo-brand" onClick={() => { navigate('/'); handleNavClick(); }}>
              <img src={logoImg} alt="Skyon Logo" className="footer-logo" />
              <div className="logo-text">
                <span className="logo-title" style={{ color: 'white' }}>SKYON</span>
                <span className="logo-subtitle" style={{ color: 'var(--color-secondary)' }}>INFRA DEVELOPERS</span>
              </div>
            </div>
            <p className="footer-desc" style={{ color: 'var(--color-text-light)', marginTop: '20px', fontSize: '0.95rem' }}>
              Redefining The Living Luxury through cutting edge designs, eco-friendly planning, and legally audited properties that bring everlasting joy to our clients.
            </p>
          </div>

          {/* Quick links */}
          <div className="footer-links-column">
            <h3 style={{ color: 'white', marginBottom: '20px', fontSize: '1.25rem', fontFamily: 'var(--font-headings)' }}>Quick Navigation</h3>
            <ul className="footer-links-list" style={{ listStyle: 'none' }}>
              {['home', 'about', 'apartments', 'villas', 'plots', 'commercial', 'farmlands', 'loans', 'contact'].map((pageId) => (
                <li key={pageId} style={{ marginBottom: '12px' }}>
                  <Link 
                    to={pageId === 'home' ? '/' : `/${pageId}`}
                    onClick={handleNavClick}
                    className="footer-nav-btn"
                    style={{ 
                      background: 'none', 
                      border: 'none', 
                      color: 'var(--color-text-light)', 
                      cursor: 'pointer',
                      fontSize: '0.95rem',
                      textAlign: 'left',
                      padding: 0,
                      textDecoration: 'none'
                    }}
                  >
                    {pageId.charAt(0).toUpperCase() + pageId.slice(1)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Address and support */}
          <div className="footer-info-column">
            <h3 style={{ color: 'white', marginBottom: '20px', fontSize: '1.25rem', fontFamily: 'var(--font-headings)' }}>Contact Support</h3>
            <p style={{ color: 'var(--color-text-light)', fontSize: '0.95rem', marginBottom: '10px' }}>
              📍 Samathapuri Colony, Samathapuri, Nagole, Hyderabad, TS - 500068
            </p>
            <p style={{ color: 'var(--color-text-light)', fontSize: '0.95rem', marginBottom: '10px' }}>
              📞 +91 90999 99149 / +91 93466 03168
            </p>
            <p style={{ color: 'var(--color-text-light)', fontSize: '0.95rem', marginBottom: '10px' }}>
              ✉ info@skyoninfradevelopers.com
            </p>
            <p style={{ color: 'var(--color-text-light)', fontSize: '0.95rem', marginBottom: '10px' }}>
              ✉ sales@skyoninfradevelopers.com
            </p>
          </div>
        </div>

        <div className="footer-bottom-bar" style={{ marginTop: '50px', paddingTop: '30px', borderTop: '1px solid rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
          <p className="footer-copyright" style={{ color: 'var(--color-text-muted)', fontSize: '0.85rem' }}>
            © {new Date().getFullYear()} Skyon Infra Developers. All Rights Reserved.
          </p>
          
          <div className="social-icons" style={{ display: 'flex', gap: '15px' }}>
            <a href="https://www.facebook.com/profile.php?id=61590403179487" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-text-muted)', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color='white'} onMouseOut={e => e.currentTarget.style.color='var(--color-text-muted)'}>
              <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
            </a>
            {/* WhatsApp Link */}
            <a href="https://wa.me/919099999149" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-text-muted)', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color='white'} onMouseOut={e => e.currentTarget.style.color='var(--color-text-muted)'}>
              <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
            </a>
            <a href="https://www.instagram.com/skyoninfra/?fbclid=IwY2xjawS9bKhleHRuA2FlbQIxMQBicmlkETF5N3kwbTF1YzdDVGpKbmJ4c3J0YwZhcHBfaWQBMAABHtHurJg-AAMaf2ezMEeN9ApbI34yrEWu1iIjMTW-H9P4gLK-7KLjWKqZwwiF_aem_IM-VjHkrcVevx_D40Pr3rQ" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-text-muted)', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color='white'} onMouseOut={e => e.currentTarget.style.color='var(--color-text-muted)'}>
              <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
            </a>
            <a href="https://www.youtube.com/@SKYONINFRADEVELOPERS" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-text-muted)', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color='white'} onMouseOut={e => e.currentTarget.style.color='var(--color-text-muted)'}>
              <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33 2.78 2.78 0 0 0 1.94 2c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
            </a>
          </div>
          
          <a className="footer-powered" href="https://vrnd.tech" target="_blank" rel="noopener noreferrer" style={{
            background: 'var(--color-secondary)',
            color: 'white',
            padding: '6px 14px',
            borderRadius: '20px',
            fontSize: '0.8rem',
            fontWeight: '600',
            textDecoration: 'none',
            display: 'inline-block',
            transition: '0.3s',
          }}
          onMouseOver={e => e.currentTarget.style.background='var(--color-secondary-dark)'} 
          onMouseOut={e => e.currentTarget.style.background='var(--color-secondary)'}
          >
            Powered by VRND Business Solutions
          </a>
        </div>
      </div>
    </footer>
  );
}
